import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
} from "@cloudscape-design/components";
import { useEffect, useState } from "react";
import SideNavigation from "@cloudscape-design/components/side-navigation";
// import SideNavMenu from "../sideNavMenu";
import { link } from "fs";

function Media() {
  // const [activeHref, setActiveHref] = useState("/media");

  return (
    <>
      <center>
        <div className="body-content">
          <ContentLayout
            header={<Header variant="h1"> Media </Header>}
          >
            <Container
              header={<Header variant="h1"> Media </Header>}
            >
            </Container>
          </ContentLayout>
        </div>
      </center>
    </>    
  );
}

export default Media;
